import React, { useState, useEffect } from 'react';
import logo from '../../../assets/images/logo.png';

import StarIcon from '../../../assets/images/star-icon.svg';
import TrashIcon from '../../../assets/images/trash-icon.svg';

import './index.css';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { DEV_API, SPORTS_CATEGORY, URL, WIN_POINT_RULES } from '../../../const/index.js';
import SideMenu from '../../../components/SideMenu.js';
import { SPORT_ADD } from "../../../store/actionTypes.js";
import Template from "../Template.js"
import CustomModal from '../../../components/Modal/modal.js';
import PaginationComponent from '../../../components/layouts/paginate.js'

const ActiveSports = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const [deleteStatus, setDeleteStatus] = useState(false);

  const [team1Idx, setTeam1Idx] = useState(-1);
  const [sportCategory, setSportCategory] = useState('NFL');
  const [events, setEvents] = useState([]);
  const [playList, setPlayList] = useState({});

  const [game, setGame] = useState(null);

  const [selectedEvt, setSelectedEvt] = useState(null);
  const [event, setEvent] = useState(null);
  const [eventId, setEventId] = useState(-1);
  const [eventDate, setEventDate] = useState();

  const [modalIsOpen, setModalIsOpen] = useState(false)

  const [primaryColor, setPrimaryColor] = useState('#0d6efd')
  const [secondaryColor, setSecondaryColor] = useState('white')

  const [totalItems, setTotalItems] = useState(1);
  const [page, setPage] = useState(1)

  useEffect(() => {
    axios.get(`${DEV_API}/api/favourites/many`, {
      params: {
        player: user._id,
        win: -1,
        page,
        limit: 5
      }
    }).then((response) => {
      const fetchedEvents = response.data.result || {};
      setEvents(fetchedEvents.games);
      setTotalItems(fetchedEvents.totalGames)
      setPage(fetchedEvents.currentPage)
    });
  }, [page])

  const handlePlayGame = (item) => {
    let apiUrl = URL[item.sportCategory];
    console.log(item, apiUrl, 'item url');

    if (item.event != -1) {
      axios.get(apiUrl,
        {
          params: {
            event: item.event
          }
        }
      ).then((response) => {
        // setPlayList(response.data);
        let playList = response.data;
        let primaryColor, secondaryColor;
        if (playList?.boxscore?.teams && playList.boxscore.teams[item.selectedTeam]) {
          const primary_col = playList.boxscore.teams[item.selectedTeam].team.color;
          const secondary_col = playList.boxscore.teams[item.selectedTeam].team.alternateColor;

          primaryColor = primary_col.includes('#') ? primary_col : `#${primary_col}`;
          secondaryColor = secondary_col.includes('#') ? secondary_col : `#${secondary_col}`;
          // setPrimaryColor(primary_col.includes('#') ? primary_col : `#${primary_col}`);
          // setSecondaryColor(secondary_col.includes('#') ? secondary_col : `#${secondary_col}`);
        }

        dispatch({
          type: SPORT_ADD, payload: {
            sportCategory: item.sportCategory,
            eventId: item.event,
            team1Idx: item.selectedTeam,
            startPos: item.startPos || 0,
            eventDate: item.gameDate,
            playList,
            primaryColor,
            secondaryColor
          }
        })

        const url = `/playGames?playerName=${user.name}&sportCategory=${item.sportCategory}&eventId=${item.event}&team1Idx=${item.selectedTeam}&startPos=${item.startPos}&primaryColor=${encodeURIComponent(primaryColor)}&secondaryColor=${encodeURIComponent(secondaryColor)}&isFree=${true}&player1Name=${item.player1Name}&player2Name=${item.player2Name}&player3Name=${item.player3Name}&player4Name=${item.player4Name}`;

        // const url = `/playFavourite?_id=${item._id}`;

        // Navigate using the URL with parameters
        navigate(url);
      })
    }
  }

  const deleteFavourite = (item) => {
    console.log(item, 'favaourite item')
    console.log({ _id: item._id }, 'item _id')

    axios.delete(`${DEV_API}/api/favourites`, {
      params: { _id: item._id }
    }).then((response) => {
      if (response.data.success) {
        toast('Game Removed!');
        setModalIsOpen(false);
      }

      axios.get(`${DEV_API}/api/favourites/many`, {
        params: {
          player: user._id,
          win: -1,
          page,
          limit: 5
        }
      }).then((response) => {
        const fetchedEvents = response.data.result || [];
        setEvents(fetchedEvents.games);
        setTotalItems(fetchedEvents.totalGames)
        setPage(fetchedEvents.currentPage)
      });
    })
  }

  const deleteAllFavourites = () => {
    axios.delete(`${DEV_API}/api/favourites/many`, {
      params: {
        player: user._id,
      }
    }).then((response) => {
      if (response.data.success) {
        toast('Game Removed!');
        setModalIsOpen(false);
      }

      axios.get(`${DEV_API}/api/favourites/many`, {
        params: {
          player: user._id,
          win: -1,
          page,
          limit: 5
        }
      }).then((response) => {
        const fetchedEvents = response.data.result || [];
        setEvents(fetchedEvents.games);
        setTotalItems(fetchedEvents.totalGames)
        setPage(fetchedEvents.currentPage)
      });
    })
  }

  return (
    <>
      <Template>
        <div className='screen-2-section'>
          <div className='screen-2-content'>
            <div className='screen-top-part'>
              <div className='logo-part'>
                <Link to="/">
                  <img src={logo} alt="logo" className='img-fluid' />
                </Link>
              </div>
              <span className='screen-title'>Saved Games</span>
            </div>
            <div className='screen-2-centerpart'>
              {/* <span className='screen-purple-glow-title'>Pick a Game</span> */}
              <Row>
                <Col xs={8}></Col>
                <Col xs={2}>
                  <div className='py-3'>
                    <img src={TrashIcon} onClick={() => { setModalIsOpen(true); setDeleteStatus(true) }} />
                  </div>
                </Col>
                <Col xs={2}></Col>
              </Row>
              <Row>
                {events.map((item, index) => (
                  <>
                    <Col xs={5} key={index} aria-disabled="true">
                      <div className='screen-2-center-detail' onClick={() => handlePlayGame(item)}>
                        <img src={item.teams && item.teams[0].team.logo} alt="team 1" className='img-fluid' style={{ width: 30, height: 30 }} />
                        <span>vs</span>
                        <img src={item.teams && item.teams[1].team.logo} alt="team 2" className='img-fluid' style={{ width: 30, height: 30 }} />
                      </div>
                    </Col>
                    <Col xs={3}></Col>
                    <Col xs={2}>
                      <div className='py-3'>
                        <img src={TrashIcon} onClick={() => { setModalIsOpen(true); setGame(item); setDeleteStatus(false); }} />
                      </div>
                    </Col>
                    <Col xs={2}></Col>
                  </>
                ))}
              </Row>
              <div className='d-flex justify-content-center'>
                <PaginationComponent
                  totalItems={totalItems}
                  itemsPerPage={5}
                  currentPage={page}
                  onPageChange={(number) => { setPage(number) }}
                />
              </div>
            </div>
          </div>
        </div>
        <CustomModal
          modalIsOpen={modalIsOpen}
          primaryColor={primaryColor}
          setModalIsOpen={setModalIsOpen}
          onRequestClose={() => setModalIsOpen(false)}
          backgroundColor='#FDDA2F'
        >
          <div className='mx-4 text-center'>
            <div>
              <span className='text-black' style={{ fontWeight: 900, fontSize: 28, fontStyle: "italic" }}>{deleteStatus ? 'REMOVE ALL SAVED GAMES' : 'REMOVE FROM SAVED'}</span>
            </div>
            {!deleteStatus && <div className='screen-2-center-detail px-5'>
              <img src={game && game.teams[0].team.logo} alt="team 1" className='img-fluid' style={{ width: 30, height: 30 }} />
              <span className='text-black'>vs</span>
              <img src={game && game.teams[1].team.logo} alt="team 2" className='img-fluid' style={{ width: 30, height: 30 }} />
            </div>}
            <div>
              <Button onClick={() => { if (deleteStatus) { deleteAllFavourites() } else { deleteFavourite(game) } }}>REMOVE</Button>
            </div>
          </div>
        </CustomModal>
      </Template>
    </>
  );
};

export default ActiveSports;
